import { CornerDownLeft } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CornerDownLeftIcon = createLucideIcon(CornerDownLeft);
